var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelsRestaurants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#626362;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.9,146.1H95.4v-4.3v-10.9h68.3c3.1,0,5.5-2.5,5.5-5.6c0-40.2-30.4-73.9-70.5-78.4l-3.3-0.4V33.8h3.8 c3.1,0,5.5-2.4,5.5-5.5s-2.4-5.5-5.5-5.5H80.7c-3.1,0-5.5,2.4-5.5,5.5s2.5,5.5,5.5,5.5h3.8v12.6l-3.3,0.4 C41,51.4,10.7,85.1,10.7,125.3c0,3.1,2.5,5.6,5.5,5.6h68.3l0.1,15.3H7c-3,0-5.5,2.4-5.5,5.5s2.5,5.5,5.5,5.5H173 c3.1,0,5.5-2.4,5.5-5.5C178.4,148.5,175.9,146.1,172.9,146.1 M21.6,119.7l0.6-4.3C27,82.1,56.1,56.9,89.9,56.9 c33.7,0,62.8,25.2,67.6,58.6l0.6,4.3H21.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelsRestaurants);
export default __webpack_public_path__ + "static/media/hotelsRestaurants.f8c959f106d1497e9b7a17638bcc0a4f.svg";
export { ForwardRef as ReactComponent };